import { Link } from "react-router-dom";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { MessageCircle, ArrowRight } from "lucide-react";
import { MaskedLines } from "../components/motion";
import { BUSINESS, IMG } from "../data/content";

export const Hero = () => {
  const reduce = useReducedMotion();
  const { scrollY } = useScroll();
  const yImg = useTransform(scrollY, [0, 600], [0, reduce ? 0 : 70]);
  const yGlow = useTransform(scrollY, [0, 600], [0, reduce ? 0 : -50]);

  return (
    <section className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden noise" data-testid="hero-section">
      <motion.div style={{ y: yGlow }} className="absolute -top-40 -left-40 w-[34rem] h-[34rem] rounded-full bg-[#6C5CE7]/18 blur-[140px] pointer-events-none" />
      <motion.div style={{ y: yGlow }} className="absolute top-1/3 -right-40 w-[28rem] h-[28rem] rounded-full bg-[#00D9C0]/12 blur-[140px] pointer-events-none" />

      <div className="container-x grid lg:grid-cols-12 gap-14 items-center relative">
        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="eyebrow mb-6"
          >
            Remote studio · Web design + Video ads
          </motion.p>
          <MaskedLines
            lines={["Websites and video ads,", "built for brands that", <span key="g" className="grad-text">sell everywhere.</span>]}
          />
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="text-[#A0A3C2] max-w-xl mt-7 leading-relaxed"
          >
            BHF Creative designs websites and produces ad videos for small businesses around
            the world. One studio, two services, and a direct line to the people doing the work.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.78, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-wrap gap-4 mt-10"
          >
            <a href={BUSINESS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="hero-whatsapp-btn" className="btn btn-wa no-underline">
              <MessageCircle size={18} /> Chat with us on WhatsApp
            </a>
            <Link to="/portfolio" data-testid="hero-work-btn" className="btn btn-ghost no-underline">
              See our work <ArrowRight size={16} />
            </Link>
          </motion.div>
        </div>

        <motion.div
          style={{ y: yImg }}
          initial={{ opacity: 0, scale: 0.94 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="relative rounded-2xl overflow-hidden border border-[rgba(255,255,255,0.1)] shadow-[0_24px_80px_rgba(108,92,231,0.25)]">
            <img
              src={IMG.hero}
              alt="Designer working at a dual-monitor desk — one screen showing a website mockup, the other a video editing timeline"
              className="w-full h-full object-cover"
              loading="eager"
              fetchpriority="high"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C1A]/60 via-transparent to-transparent" />
          </div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.1, duration: 0.7 }}
            className="absolute -bottom-5 -left-5 bg-[#1B1D33] border border-[rgba(255,255,255,0.1)] rounded-xl px-5 py-3.5 flex items-center gap-3"
          >
            <span className="w-2.5 h-2.5 rounded-full bg-[#25D366] animate-pulse" />
            <span className="text-sm font-medium">Replying on WhatsApp now</span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
